import { themeConfig } from '@gap/shared/theme'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import CircularProgress from '@mui/material/CircularProgress'
import { observer } from 'mobx-react-lite'
import XeroXpmConnect from 'features/gap-components/xero-xpm-connect/XeroXpmConnect'
import { useXpmConnectionStore } from 'features/gap-components/xero-xpm-connect/XpmConnectionStore'
import AdvisorIntegrationFYI from 'features/org/edit/integrations/FYI/AdvisorIntegrationFYI'
import { useOrgGuardStore } from 'features/main/main-router/org-guard/OrgGuardStore'
import { useCreateClientModalStore } from './CreateClientModalStore'

export default observer(function CreateClientModalSyncTab() {
   const orgGuardStore = useOrgGuardStore()
   const xpmConnectionStore = useXpmConnectionStore()
   const createClientModalStore = useCreateClientModalStore()

   return <Box>
      {xpmConnectionStore.isSyncing && <Box sx={{
         display: 'flex',
         alignItems: 'center',
         gap: 1.5,
         p: 1.5,
         mb: 2,
         borderRadius: '8px',
         backgroundColor: themeConfig.primary[100],
         border: `1px solid ${themeConfig.primary[200]}`,
      }}>
         <CircularProgress size={16} />
         <Typography variant="body2" sx={{ color: themeConfig.primary[700] }}>
            Syncing clients from XPM… this can take a couple of minutes.
         </Typography>
      </Box>}

      {orgGuardStore.hasFyiClientSyncAccess
         ? <Stack spacing={2}>
            {/* The cards' fade wrappers carry an inline margin that beats Stack's spacing, so the gap goes on plain boxes. */}
            <Box>
               <XeroXpmConnect clientSourceSlot="main-row" />
            </Box>
            <Box>
               <AdvisorIntegrationFYI source="create-client-modal" />
            </Box>
         </Stack>
         : <XeroXpmConnect showSyncAction />}

      {createClientModalStore.showConnectHint && <Box sx={{ mt: 1 }}>
         <Typography variant="caption" sx={{ color: themeConfig.primary[400] }}>
            {orgGuardStore.hasFyiClientSyncAccess
               ? 'Connect the system your clients live in to sync them here. You can also set this up later, or manage your connections at any time from your org settings.'
               : "To sync your clients, you'll be taken directly to XPM to establish a connection. You can also set this up later or manage your connection at any time from within your org settings."}
         </Typography>
      </Box>}
   </Box>
})
